var map = {
	"./arrow-black.png": 537,
	"./arrow.png": 538,
	"./buffer.png": 539,
	"./checkbox_off.png": 540,
	"./checkbox_on.png": 541,
	"./circle.png": 542,
	"./closeX.gif": 952,
	"./collapsed.png": 543,
	"./color-picker.png": 544,
	"./compass.png": 545,
	"./default.png": 546,
	"./down.png": 547,
	"./edit-all.png": 548,
	"./edit-move.png": 549,
	"./edit-rotate.png": 550,
	"./edit-scale.png": 551,
	"./edit-vertices.png": 552,
	"./edit.png": 553,
	"./eraser.png": 554,
	"./freehandLine.png": 555,
	"./icon.png": 556,
	"./identify.png": 557,
	"./json.png": 558,
	"./line.png": 559,
	"./measure-tool.png": 560,
	"./measure.png": 561,
	"./myItemsIcon.png": 562,
	"./none.png": 563,
	"./point.png": 564,
	"./polygon.png": 565,
	"./polyline.png": 566,
	"./rectangle.png": 567,
	"./select-all.png": 568,
	"./select-none.png": 569,
	"./settings.png": 570,
	"./symbolize.png": 571,
	"./symbolizer.png": 572,
	"./text.png": 573,
	"./toolbox.png": 574,
	"./triangle.png": 575,
	"./up.png": 576,
	"./zoom.png": 577
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 951;